export default __webpack_public_path__ + "static/media/self-closed.c2f32b28.svg";